<template lang="pug">
div
  v-progress-linear(v-if='loading' indeterminate color='#18bedf')
  template(v-else-if='state')
    .mb-3(style='color:#666666; font-size: 13px;')
      span {{$t('TENANT_PIPELINE.UPCHAT_ACCOUNT')}}：
      span {{ state.account_exists ? $t('TENANT_PIPELINE.CREATED') : $t('TENANT_PIPELINE.NOT_CREATED') }}
      span.ml-4 Agent Bot：
      span {{ state.agent_bot_exists ? $t('TENANT_PIPELINE.CREATED') : $t('TENANT_PIPELINE.NOT_CREATED') }}
    v-alert.mb-3(v-for='item in failures' :key='`fail-${item.user_id}`' type='error' dense text) {{ item.email || item.user_id }}：{{ item.message }}
    v-alert.mb-3(v-if='agentBotError' type='warning' dense text) Agent Bot：{{ agentBotError }}
    v-data-table.dashboard-table(:headers='headers' :items='state.users' item-key='id' hide-default-footer disable-pagination)
      template(v-slot:item.name='{ item }') {{ item.last_name }}{{ item.first_name }}
      template(v-slot:item.upchat='{ item }')
        v-checkbox.mt-0.pt-0(
          :input-value='item.has_upchat || selected.includes(item.id)'
          :disabled='item.has_upchat || busy'
          hide-details
          dense
          color='#18bedf'
          @change='toggle(item.id, $event)'
        )
    .mt-3(v-if='!state.users.length' style='color:#888888;') {{$t('TENANT_PIPELINE.NO_SUPERUSER')}}
</template>

<script>
import Vue from "vue";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";
import { errorText } from "@/components/TenantCenter/Pipeline/pipelineUtils";

export default Vue.extend({
  props: {
    tenant: { type: Object, require: true },
    busy: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      state: null,
      selected: [],
      failures: [],
      agentBotError: '',
      headers: [
        { text: i18n.t('TENANT_PIPELINE.NAME'), value: 'name', sortable: false },
        { text: i18n.t('ADD_SUPERUSER.EMAIL'), value: 'email', sortable: false },
        { text: i18n.t('TENANT_PIPELINE.UPCHAT_USER'), value: 'upchat', sortable: false, width: '130px' },
      ],
    };
  },
  async created() {
    try {
      const response = await TenantCenterService.pipelineGetStage(this.tenant.schema_name, 'upchat');
      this.state = response.data;
    } catch (error) {
      this.state = { users: [], account_exists: false, agent_bot_exists: false };
      this.failures = [{ user_id: '-', message: errorText(error) }];
    } finally {
      this.loading = false;
      this.emitStatus();
    }
  },
  methods: {
    emitStatus() {
      const dirty = this.selected.length > 0;
      this.$emit('status', { dirty: dirty, ready: !this.loading });
    },
    toggle(userId, checked) {
      this.selected = checked ? [...this.selected, userId] : this.selected.filter((id) => id !== userId);
      this.emitStatus();
    },
    async submit() {
      this.$emit('progress', i18n.t('TENANT_PIPELINE.UPDATING'));
      let data;
      try {
        const response = await TenantCenterService.pipelineUpdateStage(this.tenant.schema_name, 'upchat', { user_ids: this.selected });
        data = response.data;
      } catch (error) {
        throw new Error(errorText(error));
      }
      this.state = data;
      this.failures = (data.results || []).filter((item) => !item.success);
      this.agentBotError = data.agent_bot && !data.agent_bot.success ? data.agent_bot.message : '';
      this.selected = [];
      this.emitStatus();
      if (this.failures.length || this.agentBotError) {
        throw new Error(i18n.t('TENANT_PIPELINE.PARTIAL_FAILED'));
      }
    },
  },
});
</script>
